import React from 'react'
import EnquiryList from '../../components/admin/enquiry/EnquiryList'

function EnquiryListPage() {
  return (
    <EnquiryList/>
  )
}

export default EnquiryListPage